var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3181,29.45771c-.09167,0-.18018-.00497-.26462-.01445h-11.73154c-2.26015,0-3.1204-2.17706-3.25904-3.32858l-1.56156-18.59281h21.29912l-.08038.99889c-.13773,1.72367-1.36015,16.89172-1.75257,18.66913-.37616,1.70335-1.68168,2.26782-2.64941,2.26782ZM6.51268,9.37153l1.38996,16.55529c.00497.03116.23392,1.66677,1.41931,1.66677l11.93114.01039c.31791.03567.74555-.07587.90812-.81329.28901-1.30732,1.21158-12.20795,1.63471-17.41916,0,0-17.28324,0-17.28324,0Z",
    strokeWidth: 0,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.39651,9.41443c-.10973,0-.21089-.00542-.3012-.0149l.19237-1.83973h0c.0009.00045.74465.05283,1.04856-.33823.03432-.37345-.4299-1.44731-1.04269-2.44529H6.01684c-.36352.59608-1.01334,1.73677-1.3159,2.72663-.00271.00813-.00497.01581-.00677.02348.17702.03613.47416.03793.66653.00723l.29262,1.82618c-.27772.04471-1.69658.22218-2.43536-.62634-.2285-.26237-.56989-.84174-.2863-1.77064.51073-1.67129,1.75302-3.54534,1.80586-3.62436l.27456-.41184h20.2781l.27501.40777c.85619,1.26984,2.17028,3.58869,1.35338,4.85085-.6304.9736-1.77109,1.22919-2.52206,1.22919ZM25.33173,7.25364h0Z",
    strokeWidth: 0,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.53996,4.77628h-3.25136c-1.16733,0-2.117-.94967-2.117-2.117s.94967-2.117,2.117-2.117h3.25136c1.16733,0,2.117.94967,2.117,2.117s-.94967,2.117-2.117,2.117ZM13.2886,2.39195c-.14721,0-.26733.12012-.26733.26733s.12012.26733.26733.26733h3.25136c.14721,0,.26733-.12012.26733-.26733s-.12012-.26733-.26733-.26733c0,0-3.25136,0-3.25136,0Z",
    strokeWidth: 0,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.14225,26.09075c-.36397,0-.66924-.28314-.69182-.65118l-.91038-14.78285c-.02348-.38203.26733-.71123.64982-.73472.39061-.02393.71123.26733.73472.64982l.91038,14.78285c.02348.38203-.26733.71123-.64982.73472-.01445.0009-.0289.00135-.0429.00136Z",
    strokeWidth: 0,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.15271,26.09075c-.38294,0-.69362-.31069-.69362-.69362v-14.78285c0-.38294.31069-.69362.69362-.69362s.69362.31069.69362.69362v14.78285c0,.38294-.31069.69362-.69362.69362Z",
    strokeWidth: 0,
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.29323,26.09075c-.014,0-.02845-.00045-.0429-.00135-.38249-.02348-.6733-.35268-.64982-.73472l.91038-14.78285c.02348-.38203.34771-.66834.73472-.64982.38249.02348.6733.35268.64982.73472l-.91038,14.78285c-.02258.36804-.32785.65118-.69182.65117Z",
    strokeWidth: 0,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.6c75031833f8d23c4148804c83c0c5b5.svg";
export { ForwardRef as ReactComponent };